module.exports = __webpack_public_path__ + "static/media/12nanbu.36952c8f.png";